<template>
  <div class="recoverPassword container-fluid">
    <b-alert :show="errorAlertShown"
        dismissible
        variant="danger"
        @dismissed="errorAlertShown=0"
        @dismiss-count-down="countDownChanged">
      <p>{{ $t('LNG_ERROR_SENDING_NEW_PASSWORD', this.lang) }}</p>
    </b-alert>
    <b-alert :show="showSuccess"
        dismissible
        variant="evaobj"
        @dismissed="showSuccess=0"
        @dismiss-count-down="countDownChanged">
      <p>{{ $t('LNG_NEW_PASSWORD_SENT', this.lang) }}</p>
    </b-alert>
    <b-form @submit="recoverPassword">
      <b-row>
        <b-col cols="12">
          <img :title="$t('LNG_TITLE', this.lang)" :alt="$t('LNG_TITLE', this.lang)" width="200px" src="../assets/img/logo.jpg">
          <h2>{{ $t('LNG_TITLE_RECOVER_PASSWORD', lang) }}</h2>
        </b-col>
      </b-row> 
      <b-row class="my-1">
        <b-col sm="3" lg="4"></b-col>
        <b-col sm="6" lg="4">
           <b-input-group>       
              <b-input-group-text slot="prepend">
                 <i class="fa fa-fw fa-user"></i>
              </b-input-group-text>
              <b-form-input type="email" class="form-control" id="email" v-model="username" :placeholder="$t('LNG_EMAIL', lang)" required autofocus autocapitalize="off"></b-form-input>
           </b-input-group>
        </b-col>
      </b-row>
      <b-row class="my-3">  
        <b-col sm="3" lg="4"></b-col>
        <b-col sm="6" lg="4">
           <b-button variant="evaobj" type="submit">{{ $t('LNG_RECOVER_PASSWORD', lang) }}</b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { focus } from 'vue-focus'
export default {
  name: 'recoverPassword',
  components: {
  },
  data () {
    return {
      username: '',
      errorAlertShown: 0,
      showSuccess: 0,
      dismissSecs: 5,
      focus: ''
    }
  },
  mounted: function () {
    this.focus = 'username'
  },
  computed: {
    ...mapState([
      'api',
      'fullname',
      'lang'
    ])
  },
  directives: {
    focus: focus
  },
  methods: {
    setErrorMessage (errorTag = '') {
      this.errorMessage = errorTag
    },
    countDownChanged (dismissCountDown) {
      this.successAlertShown = dismissCountDown
    },
    recoverPassword: function () {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'resetPassword',
          username: this.username
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        if (response.data.status === 'OK') {
          this.showSuccess = this.dismissSecs
          this.$router.push({ path: '/' })
        } else {
          this.successAlertShown = this.dismissSecs
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.login {
  margin-top: 50px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// recoverPassword.vue?07ea3c11